<div class="progress-bar-container" [ngStyle]="{ 'width': '100%', 'z-index': '100' }"
(mousemove)="onMouseMove($event)" 
(mouseleave)="onMouseLeave()"
(click)="onMouseClick($event)">
  <div class="progress-bar" [ngStyle]="{ 'width': '100%' }">
    <div 
      class="segment" 
      *ngFor="let item of fullTimeline;" 
      [ngStyle]="{
        'background-color': getSegmentColor(item.type),
        'width': getSegmentWidth(item.duration) + '%',
        'left': getSegmentWidth(getMinutesFromStartOfInterval(item.start_time)) + '%',
      }"
      >
    </div>
    <div (mousemove)="showCurrentTimeLabel()"
      (mouseleave)="onMouseLeave()" (mouseover)="showCurrentTimeLabel()"
      class="current-time-marker time-marker"
      [ngStyle]="{ 'left': currentTimePosition, 'width': '2px', 'height': '10px', 'background-color': 'red', 'display': (currentTimePosition === '-1%' )? 'none' : 'block'}">
      </div>
  </div>
  <div class="date-label" *ngIf="showLabel" [ngStyle]="labelPosition">
    {{ dateLabel | date: 'dd/MM/yyyy HH:mm:ss'}}
  </div>
</div>
